/**
 * Tiny global store for tracking when the last successful `/api/*` response
 * came in and whether it was served from the service-worker cache.
 *
 * Updated by the axios response interceptor in `utils/api.js` based on
 * the `x-sw-cached-at` header injected by `public/sw.js`.
 *
 * Consumed by `<LastSyncedPill />` and any other UI that wants to render
 * a "Synced 2:14pm" indicator.
 */
const subscribers = new Set();
let state = { lastSyncAt: null, fromCache: false };

export const getSyncStatus = () => state;

export const subscribeSyncStatus = (cb) => {
  subscribers.add(cb);
  return () => subscribers.delete(cb);
};

export const setSyncStatus = (next) => {
  state = { ...state, ...next };
  subscribers.forEach((cb) => {
    try { cb(state); } catch (_e) { /* swallow */ }
  });
};
